<div class="bg-white rounded-lg border border-gray-200 p-4 {{ sectionClass }}">
  <div class="flex items-center gap-2 mb-4 pb-2 border-b border-gray-100 {{ headerClass }}">
    <mat-icon [ngClass]="iconColorClass">{{ icon }}</mat-icon>
    <h3 class="text-sm font-semibold text-gray-700 uppercase tracking-wide">{{ title }}</h3>
  </div>
  <div class="{{ contentClass }}">
    <ng-content></ng-content>
  </div>
</div>